























































import Vue from 'vue';
import { Level, PersonalizedCourse } from '@/store/types';
import LearningTools from '@/tools/learning';
import RoutePaths from '@/router/route_paths';
import Base64 from 'crypto-js/enc-base64';
import Utf8 from 'crypto-js/enc-utf8';

export default Vue.extend({
  name: 'LevelsPersonalized',
  data() {
    return {
      loading: true,
      deleteDialog: false,
      deleteCourse: null as PersonalizedCourse | null,
    };
  },
  async mounted(): Promise<void> {
    this.$store.commit('setMainLoading', false);
    if (!this.$route.query.noInit) {
      this.loading = true;
      await LearningTools.loadLevelsPersonalized(this.$store);
    }
    this.loading = false;
  },
  methods: {
    onLevel(level: Level): void {
      this.$store.commit('setLevel', level);
      this.$router.push(RoutePaths.UNITS);
    },
    async onExportPDF(): Promise<void> {
      await LearningTools.updateLastActionTime(this.$store);
      let url = `${this.$store.getters.URL_PERSONALIZED_COURSES_PDF}?_=`;
      url += Base64.stringify(Utf8.parse(`id=${this.$store.state.personalizedCourse.id}`));
      url += `&fuid=${this.$store.state.user.uid}`;
      window.open(url, '_blank');
    },
  },
});

